import React, { useContext } from 'react'
import { Button as ButtonComp, Spacer } from '@sencha/ext-modern'

import { reconfigButton, isHelpBtn } from 'tyan/public/utility'
import { IsDialogContext } from 'tyan/public/components/context'
import { useDelayTimer, useInstData } from 'tyan/public/hooks'

const Button = ({ config }) => {
	const isDialog = useContext(IsDialogContext)
	const o = reconfigButton(config)
	// auto: 
	const { icon, auto, ui = Tyan.isPhone ? '' : 'action', ...rest } = o
	const { handler, disabled } = o

	const { me } = useInstData()
	const { doDelay } = useDelayTimer(auto)

	doDelay(() => {
		// console.log('o:', o)
		handler(me.button)
	}, !!(auto && !disabled))

	return <>
		<ButtonComp ref={ref => ref && (me.button = ref.cmp)}
			text={o._button} ui={ui} {...(icon ? { iconCls: `x-fa fa-${icon}` } : {})}
			{...Tyan.isPhone ? { margin: '4 10 4 0' } : { shadowfalse: true, margin: '4 10 4 0' }}
			{...rest}
		/>
		{(isDialog || Tyan.isPhone) && !isHelpBtn(config) && <Spacer /> || null}
	</>
}

export default Button